import { Autocomplete, TextField } from "@mui/material";
import { AutocompleteProps } from "../../../interfaces/IForms";

export default function AutocompleteSelect<T>({
  disabled = false,
  options,
  label,
  getOptionLabel,
  onChange,
  noOptionsText,
  fullWidth = true,
}: AutocompleteProps<T>) {
  return (
    <Autocomplete
      disabled={disabled}
      filterSelectedOptions
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={(option, value) => getOptionLabel(option) === getOptionLabel(value)}
      onChange={(event, value) => onChange(value)}
      options={options}
      noOptionsText={noOptionsText || "Brak opcji"}
      renderInput={(params) => (
        <TextField {...params} label={label} variant="outlined" fullWidth={fullWidth} />
      )}
      renderOption={(props, option) => (
        <li {...props} key={(option as any).id}>
          {getOptionLabel(option)}
        </li>
      )}
      size="small"
    />
  );
}
